import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaUnderlyingPolicies({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.ULType)}</th>
                    <th>{translator(messages.ULLimit)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.UnderlyingInsurance)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((coverage) => {
                            return (
                                <>
                                    <tr>
                                        <td><strong>{coverage.name}</strong></td>
                                        <td>{coverage.terms[0].chosenTermValue}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaUnderlyingPolicies.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLUmbrellaUnderlyingPolicies.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaUnderlyingPolicies;
